(function() {
  var SELECTOR_SECTION = '[data-offer-how-section]';
  var SELECTOR_CAROUSEL = '[data-offer-how-carousel]';
  var DESKTOP_MEDIA = '(min-width: 1080px)';

  function hasSlick() {
    return window.jQuery && jQuery.fn && typeof jQuery.fn.slick === 'function';
  }

  function initCarousel(carousel) {
    if (!carousel) return;

    var mq = window.matchMedia(DESKTOP_MEDIA);
    var $carousel = window.jQuery(carousel);

    function toggle() {
      if (!hasSlick()) return;

      if (mq.matches) {
        if ($carousel.hasClass('slick-initialized')) return;
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="offer-how-it-works__arrow is-prev" aria-label="Previous slide"></button>',
          nextArrow: '<button type="button" class="offer-how-it-works__arrow is-next" aria-label="Next slide"></button>',
          customPaging: function() {
            return '<button type="button" aria-label="Slide"></button>';
          }
        });
      } else if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', toggle);
    } else if (mq.addListener) {
      mq.addListener(toggle);
    }

    toggle();
  }

  function initForSection(section) {
    if (!section) return;
    var carousel = section.querySelector(SELECTOR_CAROUSEL);
    if (!carousel) return;
    initCarousel(carousel);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(initForSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event && event.target && event.target.matches && event.target.matches(SELECTOR_SECTION)) {
      initForSection(event.target);
    }
  });
})();
